export const MESSAGE_TYPE_SEND = 'send';
export const MESSAGE_TYPE_RECEIVE = 'receive';
export const MESSAGE_TYPING_WAIT = 5000;
export const MESSAGE_IMAGE_TAG = '#Attachments:';

export const ACCOUNT_TYPE_RELATIVE = 'customer';
export const ACCOUNT_TYPE_SENIOR = 'device';
